// src/pages/DeleteTablePage.js
import React, { useState } from "react";
import { Container, Row, Col, Form, Modal, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";

import PageHeader from "./components/PageHeader";
import TableList from "./components/TableList";
import TableForm from "./components/TableForm";
import { useTables } from "./components/useTables";
import { useUser } from "../UserContext"; // importa il contesto utente

import "react-toastify/dist/ReactToastify.css";
import "../../css/DBTablePage.css";


function DeleteTablePage() {

  const { role } = useUser(); // Ottieni il ruolo dell’utente loggato

  const [selectedTable, setSelectedTable] = useState("");
  const [showModal, setShowModal] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;
  const { tables, fetchTables } = useTables(API_URL);

  const handleDelete = async () => {
    if (!selectedTable) return toast.warning("Seleziona una tabella da eliminare.");

    const formData = new URLSearchParams();
    formData.append("tableName", selectedTable);

    try {
      const res = await fetch(`${API_URL}/deleteTableDB`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });

      if (!res.ok) throw new Error("Errore durante l'eliminazione della tabella");

      const data = await res.json();
      toast.success(`Tabella "${data.table}" eliminata con successo`);

      // Aggiorna l'elenco tabelle
      await fetchTables();
      setSelectedTable("");
      setShowModal(false);
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Errore imprevisto");
      setShowModal(false);
    }
  };

  // Se utente non loggato, mostra solo un messaggio
  if (!role) {
    return (
      <Container className="mt-5 text-center">
        <h5>Effettua il login per effettuare l'operazione</h5>
      </Container>
    );
  }



  return (
    <Container className="mt-5">
      <ToastContainer position="top-right" autoClose={3000} />
      <PageHeader title="Eliminazione tabella" />

      <Row className="mt-5 mb-5 justify-content-center align-items-stretch g-4">
        {/* Colonna sinistra: elenco tabelle */}
        <Col xs={12} md={6}>
          <TableList tables={tables} />
        </Col>

        {/* Colonna destra: form di eliminazione */}
        <Col xs={12} md={6}>
          <TableForm
            title="🗑️ Elimina una tabella"
            buttonLabel="ELIMINA TABELLA"
            buttonDisabled={!selectedTable}
            buttonVariant="danger"
            onSubmit={(e) => {
              e.preventDefault();
              setShowModal(true);
            }}
          >
            <Form.Group controlId="selectTable" className="mb-4">
              <Form.Label><strong>Seleziona tabella da eliminare</strong></Form.Label>
              <Form.Select
                value={selectedTable}
                onChange={(e) => setSelectedTable(e.target.value)}
              >
                <option value="">-- Seleziona una tabella --</option>
                {tables.map((item) => (
                  <option key={item.name} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </TableForm>
        </Col>
      </Row>

      {/* Modal di conferma */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Conferma eliminazione</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Sei sicuro di voler eliminare la tabella <strong>{selectedTable}</strong>? <br />
          <span className="text-danger fw-semibold">Questa azione è irreversibile.</span>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Annulla
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Elimina
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default DeleteTablePage;
